module.exports = new __parcel__URL__("query.99507992.png").toString();